import { render, staticRenderFns } from "./AcuerdosColaboracion.vue?vue&type=template&id=78430352&scoped=true&"
var script = {}
import style0 from "./AcuerdosColaboracion.vue?vue&type=style&index=0&id=78430352&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78430352",
  null
  
)

export default component.exports